<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="アカウントの作成"
        width="40"
        class="mb30"
      /><br />{{ $t("accountCreate") }}
    </h2>
    <div class="account-box">
      <p class="txt-mail">
        <span v-if="!$v.email.required || !$v.email.email">{{
          $t(this.getMessage($v.email, { name: "メールアドレス" }))
        }}</span>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email"
          v-model.trim="$v.email.$model"
        />
      </p>
      <p class="txt-pw">
        <span
          v-if="
            !$v.password.required ||
              !$v.password.minLength ||
              !$v.password.maxLength ||
              !$v.password.alphaNum ||
              !$v.password.match
          "
        >
          {{
            $t(
              this.getMessage($v.password, {
                name: "パスワード",
                type: "OnebyOne",
              })
            )
          }}
        </span>
        <span class="txt-info">
          {{ $t("passwordRequirement") }}
        </span>
        <input
          type="password"
          id="pw"
          name="pw"
          placeholder="Password"
          v-model.trim="$v.password.$model"
        />
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="this.$v.$invalid && this.vaError" />
      <firebaseError :error="this.fbError" :errorCode="errorCode" />
    </p>
    <p class="kiyaku">
      <input type="checkbox" id="kiyaku" name="kiyaku" v-model="checkedTerms" />
      <label for="kiyaku">
        <router-link class="under-line" :to="{ name: 'Terms' }" target="_blank"
          >{{ $t("userTerms") }}{{ $t("confirmLink") }}</router-link
        >、
        <br />
        <a class="under-line" href="https://3platz.jp/#contact" target="_blank"
          >{{ $t("privacyPolicy") }}{{ $t("confirmLink") }}</a
        >、
        <br />
        <a
          class="under-line"
          href="https://3platz.jp/point-terms/"
          target="_blank"
          >{{ $t("pointTerms") }}{{ $t("confirmLink") }}</a
        >
        {{ $t("agree") }}</label
      >
    </p>
    <p class="center">
      <button
        class="btn-normal"
        @click="signUp"
        v-bind:disabled="!checkedTerms"
      >
        {{ $t("accountCreate") }}
      </button>
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import firebaseError from "@/error/FirebaseError";
import validationError from "@/error/ValidationError";
import {
  required,
  email,
  alphaNum,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import i18n from "../../i18n";
import redirectEnum from "@/constants/redirectEnum";
//import partnerIdEnum from '@/constants/partnerIdEnum'

export default {
  name: "Signup",
  data() {
    return {
      email: "",
      password: "",
      checkedTerms: false,
      vaError: false, //バリデーションエラー
      fbError: false, //firebaseエラー
      errorCode: "",
      db: firebase.firestore(),
      from: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      alphaNum,
      match() {
        return this.isNotEmpty(this.isMatch(this.password, "oneByOne"));
      },
    },
    email: {
      required,
      email,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  methods: {
    async signUp() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.vaError = true;
      } else {
        firebase.auth().languageCode = i18n.locale;
        //firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        let redirectId = this.$route.params.redirectId;
        let pid = this.$route.params.pid;
        let source =
          window.location.protocol +
          "//" +
          window.location.host +
          this.from.path;

        if (pid == "0200001400" && redirectId == "job") {
          source =
            window.location.protocol +
            "//" +
            window.location.host +
            this.from.path.replace("job", "shopping");
          pid = "0600001400";
          redirectId = "shopping";
        }
        const userCredential = await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .catch(async (error) => {
            const errorRef = this.db.collection("errorLog").doc();
            await errorRef.set({
              error: error.code,
              errorDetails: error.message,
              created_at: firebase.firestore.FieldValue.serverTimestamp(),
            });
            this.errorCode = error.code;
            this.fbError = true;
            return;
          });
        if (userCredential !== undefined) {
          await userCredential.user
            .sendEmailVerification()
            .catch(async (error) => {
              const errorRef = this.db.collection("errorLog").doc();
              await errorRef.set({
                error: error.code,
                errorDetails: error.message,
                created_at: firebase.firestore.FieldValue.serverTimestamp(),
              });
              this.errorCode = "email-verification-error";
              this.fbError = true;
              return;
            });

          this.$router.push({ name: "VerifyEmailSend" });

          //log
          const logRef = this.db.collection("usersLog").doc();
          await logRef.set({
            uid: userCredential.user.uid,
            type: "signup",
            created_at: firebase.firestore.FieldValue.serverTimestamp(),
          });
          //create user
          const userRef = this.db
            .collection("users")
            .doc(userCredential.user.uid);
          await userRef.set({
            created_at: firebase.firestore.FieldValue.serverTimestamp(),
            nickname: "",
            status: "0",
          });
          if (
            redirectId !== undefined &&
            redirectEnum.redirects[redirectId] !== undefined
          ) {
            await logRef.set({ redirectId: redirectId }, { merge: true });
            await userRef.update({ redirectId: redirectId });

            if (pid !== undefined) {
              // only register known pid
              //if(partnerIdEnum.partnerIds.includes(pid)){
              source += "?pid=" + pid;
              await userRef.update({ pid: pid });
              await logRef.set({ pid: pid }, { merge: true });
              //}
            }
          }
          await userRef.set({ source: source }, { merge: true });
          await logRef.set({ source: source }, { merge: true });
        }
      }
    },
  },
};
</script>
